<klarna-express-button data-testid="express-checkout-button" data-locale="en-CA" data-theme="default"></klarna-express-button>